var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Zonas habilitadas","storeName":"Places","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }